import { Provider } from 'react-redux';
import ThemeProvider from '@guestyci/foundation/theme/ThemeProvider';
import ToastProvider from '@guestyci/foundation/Toast';
import LocalizationProvider from '@guestyci/localize/LocalizationProvider';

import store from './store';
import AppRouter from './AppRouter';
import { AutoLoginSuspense } from './module/Authorization';
import AuthorizationProvider from './module/Authorization/AuthorizationContainer';
import useOnMessagingCommunication from './module/subscribers/useOnMessagingCommunication';

const App = () => {
  useOnMessagingCommunication();

  return (
    <ThemeProvider themeVariant="guestyForHosts">
      <Provider store={store}>
        <LocalizationProvider>
          <ToastProvider>
            <AuthorizationProvider>
              <AutoLoginSuspense fallback={<div />}>
                <AppRouter />
              </AutoLoginSuspense>
            </AuthorizationProvider>
          </ToastProvider>
        </LocalizationProvider>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
